import React, { createElement, useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { HTTP } from './http';
import { Table, EditableTable } from '../components/table';

import { useExternalScripts } from './useExternalScripts';

export function useMods() {
  const [webMods, setWebMods] = useState([]);

  useEffect(() => {
    async function getMods() {
      const mods = await HTTP.getMods();
      setWebMods(mods);
    }
    getMods();
  }, []);

  const { mods, loading } = useExternalScripts(webMods);

  if (mods && !loading) {
    if (mods.length !== webMods.length) {
      console.error('Mods length mismatch, are all IDs mapped correctly between js mods and backend response?', mods, webMods);
    }
  }

  return mods;
}

/**
 * Add references to the main React application inside mod components
 */
export function hydrateModComponent(component, extra = {}) {
  return createElement(component, { React, styled, HTTP, Table, EditableTable, ...extra });
}
